import type { JSX } from 'preact'
import { forwardRef } from 'preact/compat'

export type Props = Omit<JSX.IntrinsicElements['button'], 'loading'> & {
    loading?: boolean
}

const PureButton = forwardRef<HTMLButtonElement, Props>(
    ({ type = 'button', class: _class = '', loading, disabled, children, ...props }, ref) => (
        <button {...props} className={_class} disabled={disabled || loading} type={type} ref={ref}>
            {loading ? <span class='loading loading-spinner' /> : children}
        </button>
    ),
)

export default PureButton
